import React from "react";

import { css, cx } from "@emotion/css";

import { usePatientFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AlertsButton } from "@/uiKit/molecules/PatientNavigation/AlertsButton.tsx";
import { CarePlanManagementActions } from "@/uiKit/molecules/PatientNavigation/CarePlanManagementActions.tsx";
import { NurseNoticeButton } from "@/uiKit/molecules/PatientNavigation/NurseNoticeButton.tsx";
import { NurseReinclusionButton } from "@/uiKit/molecules/PatientNavigation/NurseReinclusionButton.tsx";
import { PhoneButton } from "@/uiKit/molecules/PatientNavigation/PhoneButton.tsx";

export type PatientActionsProps = {
  className?: string;
};

export const PatientActions: React.FC<PatientActionsProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const patient = usePatientFromURL();
  const me = Queries.user.usePractitionerMe({});
  const isNurse = me.qualification === "nurse";
  const isDoctor = me.qualification === "doctor";

  return (
    <div className={cx(styles.container, className)}>
      {isNurse && <PhoneButton patientId={patient.id} />}
      <AlertsButton patientId={patient.id} />
      {isNurse && <NurseNoticeButton patientId={patient.id} />}
      {isNurse && <NurseReinclusionButton patientId={patient.id} />}
      {isDoctor && <CarePlanManagementActions patientId={patient.id} />}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(12),
  }),
});
